export const ACTIVE_CAMPAIGN_FORM_IDS = {
  BLOG_HERO: 18,
  PODCAST_HERO: 20,
  LANDLORD_CTA: 12,
  BTR_CTA: 16,
  TENANT_HERO: 14,
};

export const ACTIVE_CAMPAIGN_FORM_METAORS = {
  BLOG_HERO: '6b05905aa2f5200818b9d7632dbf7217',
  PODCAST_HERO: '7ff2794f678d1f64173f6c89d6232e10',
  LANDLORD_CTA: 'd8399e77d7371f0a5316289fe329efe8',
  BTR_CTA: '1873c019bc533d2f233a726a4fc9158d',
  TENANT_HERO: '92d196d1024d3bd40ac26caefa927eec',
};

export const addToActiveCampaign = (id, metaOr, values) => {
  return fetch('https://oasis-living.activehosted.com/proc.php', {
    method: 'POST',
    body: getFormData({
      u: id,
      f: id,
      s: '',
      c: 0,
      m: 0,
      act: 'sub',
      v: 2,
      or: metaOr,
      ...values,
    }),
    mode: 'no-cors',
  });
};

function getFormData(object) {
  const formData = new FormData();
  Object.keys(object).forEach(key => formData.append(key, object[key]));
  return formData;
}
